export const AI_API_ACCESS_TOKEN = 'fb34e7cbca8bcac576a4ce31c9dc28ba';
